export default {
  favorites: null
}
